import { faMoon, faSun } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useAppContext } from '../../context/AppContext';

/**
 * @param {'nav' | 'floating'} [variant='nav']
 */
const ThemeToggle = ({ variant = 'nav' }) => {
    const { theme, toggleTheme } = useAppContext();
    const isDark = theme === 'dark';

    return (
        <button
            type="button"
            className={`theme-toggle theme-toggle--${variant}`}
            onClick={toggleTheme}
            aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
            aria-pressed={isDark}
            title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
        >
            <FontAwesomeIcon icon={isDark ? faSun : faMoon} className="theme-toggle__icon" aria-hidden="true" />
            {isDark ? 'Light' : 'Dark'}
        </button>
    );
};

export default ThemeToggle;
